import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            as: 'section',
            width: '100%',
            bg: 'transparent',
            gap: {
                base: 'xsmall.base',
                md: 'xsmall.md',
                lg: 'xsmall.lg',
                xl: 'xsmall.xl',
            },
        },
        titleUpgrade: {
            gap: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
        },

        title: {
            textStyle: 'body-medium',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        subtitle: {
            textStyle: 'body-medium',
            color: 'foreground.neutral.subtle',
            fontWeight: 'normal',
        },
        card: {
            spacing: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            bg: 'transparent',
            borderRadius: 'large-1',
            boxShadow: `0 0 0 ${remCalc(
                1,
            )} var(--chakra-colors-border-neutral-highlight) inset, 0 ${remCalc(1)} ${remCalc(
                2,
            )} 0 var(--chakra-shadows-neutral-xs), 0 0 0 ${remCalc(
                1,
            )} var(--chakra-shadows-neutral-xs)`,
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        topRow: {
            alignItems: 'center',
            gap: {
                base: 'xxsmall-1.base',
                md: 'xxsmall-1.md',
                lg: 'xxsmall-1.lg',
                xl: 'xxsmall-1.xl',
            },
        },
        bottomRow: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: {
                base: 'xsmall.base',
                md: 'xsmall.md',
                lg: 'xsmall.lg',
                xl: 'xsmall.xl',
            },
        },
        imagePlaceholder: {
            boxSize: remCalc(62),
            minW: remCalc(62),
            maxW: remCalc(62),
        },
        content: {
            flex: 1,
            spacing: 'micro.base',
            minW: 0,
        },
        productName: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
            lineHeight: remCalc(18),
            noOfLines: 1,
        },
        productDescription: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
            noOfLines: 1,
            //mb: 'xxsmall-1.base',
        },
        priceRow: {
            spacing: 'xxxsmall.base',
        },
        priceValues: {
            alignItems: 'center',
            gap: {
                base: 'xxsmall.base',
                md: 'xxsmall.md',
                lg: 'xxsmall.lg',
                xl: 'xxsmall.xl',
            },
        },
        currentPrice: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'foreground.neutral.default',
        },
        listPrice: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
            textDecoration: 'line-through',
        },
        discount: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
        },
        omnibusPrice: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
        },
        addButton: {
            display: 'flex',
            w: remCalc(36),
            h: remCalc(36),
            alignItems: 'center',
            justifyContent: 'center',
            gap: {
                base: 'medium-1.base',
                md: 'medium-1.md',
                lg: 'medium-1.lg',
                xl: 'medium-1.xl',
            },
            flexShrink: 0,
            aspectRatio: 1,
            borderRadius: 'large',
            bg: 'background.neutral.default',
            boxShadow: 'borderShadow',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            cursor: 'pointer',
        },
        addButtonIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
        skeletonImage: {
            boxSize: remCalc(62),
            minW: remCalc(62),
            borderRadius: 'medium-1',
        },
        skeletonProductName: {
            height: remCalc(14),
            width: remCalc(140),
            borderRadius: 'sm',
        },
        skeletonProductDescription: {
            height: remCalc(12),
            width: remCalc(100),
            borderRadius: 'sm',
        },
        skeletonPrice: {
            height: remCalc(16),
            width: remCalc(80),
            borderRadius: 'sm',
        },
        skeletonButton: {
            w: remCalc(36),
            h: remCalc(36),
            borderRadius: 'large',
            flexShrink: 0,
        },
    },
}
